import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://areco.gob.ar:9525/api/test/';


class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
  getPrensaBoard() {
    return axios.get(API_URL + 'prensa', { headers: authHeader() });
  }
  
}

export default new UserService();
